import React from "react";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Button, Modal, Input } from "ui-kit-sahadevia";

import {
  addBankStatement,
  updateBankStatement,
} from "../../requests/bankStatement";

export default class ModalBankStatement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      nameFile: "",
      priceInput: "",
      priceOutput: "",
      month: "",
      base64: "",
      mime: "",
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleInputFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.setState({
          nameFile: file.name,
          mime: file.type,
          base64: reader.result,
        });
      };
      reader.onerror = () => {
        this.refFile.value = "";
        this.setState({
          mime: "",
          base64: "",
        });
        alert("Une erreur est survenue");
      };
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.isUpdate &&
      this.props.show &&
      JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)
    ) {
      this.setState({
        name: this.props.data.name,
        priceInput: this.props.data.priceInput,
        priceOutput: this.props.data.priceOutput,
        month: moment(this.props.data.month, "MM/YYYY").format("YYYY-MM"),
      });
    }
  }

  addBankStatement = () => {
    if (
      this.state.name &&
      this.state.priceInput &&
      this.state.priceOutput &&
      this.state.month &&
      this.state.base64 &&
      this.state.mime
    ) {
      addBankStatement(
        this.state.name,
        this.state.priceInput,
        this.state.priceOutput,
        this.state.month,
        this.state.base64,
        this.state.mime,
        (result) => {
          if (result.success) {
            this.onClose(true);
          } else {
            alert("Une erreur est survenue");
          }
        }
      );
    } else {
      alert("Veuillez remplir tous les champs obligatoires");
    }
  };

  updateBankStatement = () => {
    if (
      this.state.name &&
      this.state.priceInput &&
      this.state.priceOutput &&
      this.state.month
    ) {
      updateBankStatement(
        this.props.data.id,
        this.state.name,
        this.state.priceInput,
        this.state.priceOutput,
        this.state.month,
        (result) => {
          if (result.success) {
            this.onClose(true);
          } else {
            alert("Une erreur est survenue");
          }
        }
      );
    } else {
      alert("Veuillez remplir tous les champs obligatoires");
    }
  };

  onClose = (isReload) => {
    this.setState(
      {
        name: "",
        nameFile: "",
        priceInput: "",
        priceOutput: "",
        month: "",
        base64: "",
        mime: "",
      },
      () => {
        this.props.onClose(isReload);
      }
    );
  };

  render() {
    return (
      <>
        <Modal show={this.props.show} title={this.props.title}>
          <Input
            title="Nom"
            type="text"
            placeholder="Nom"
            name="name"
            value={this.state.name}
            onChange={this.handleInputChange}
          />
          <Input
            title="Entrées (en €)"
            type="text"
            placeholder="Entrées"
            name="priceInput"
            value={this.state.priceInput}
            onChange={this.handleInputChange}
          />
          <Input
            title="Sorties (en €)"
            type="text"
            placeholder="Sorties"
            name="priceOutput"
            value={this.state.priceOutput}
            onChange={this.handleInputChange}
          />
          <Input
            title="Mois"
            type="month"
            placeholder="Mois"
            name="month"
            value={this.state.month}
            onChange={this.handleInputChange}
          />
          {!this.props.isUpdate ? (
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <Button
                icon={faFile}
                text="Sélectionner un fichier"
                onClick={() => this.refFile.click()}
              />
              <span
                style={{
                  display: "inline-block",
                  margin: "auto",
                  marginLeft: "1rem",
                  fontSize: "12px",
                }}
              >
                {this.state.nameFile}
              </span>
            </div>
          ) : null}

          <div style={{ display: "flex" }}>
            <Button
              style={{ marginLeft: "auto" }}
              text="Annuler"
              onClick={() => this.onClose(false)}
            />
            <Button
              text={this.props.isUpdate ? "Modifier" : "Ajouter"}
              onClick={
                this.props.isUpdate
                  ? this.updateBankStatement
                  : this.addBankStatement
              }
            />
          </div>
        </Modal>
        <input
          style={{ display: "none" }}
          ref={(ref) => (this.refFile = ref)}
          type="file"
          name="file"
          onChange={this.handleInputFileChange}
        />
      </>
    );
  }
}
